import { useContext } from "react";
import { Paper } from "@mui/material";
import "./ChatterApp.scss";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import LoginPage from "./pages/Login";
import { RaceSchedule } from "./pages/RaceSchedule";
import { LoginContext } from "./context/login.context";
import { RaceDashboard } from "./pages/RaceDashboard";
import { CurrentRaceEventContext } from "./context/currentRaceEvent.context";
import AutoPlayPopover from "./components/AutoPlayPopover";
import { useAutoPlayEvents } from "./hooks/useAutoPlayEvents";
import { RaceDashboardLayoutContext } from "./context/raceDashboardLayout.context";
import RaceEndedOverlay from "./components/RaceEndedOverlay/RaceEndedOverlay";
import { ToastContainer } from "react-toastify";
import ForgotPassword from "./pages/ForgotPassword";
import ForgotPasswordConfirmation from "./pages/ForgotPasswordConfirmation";
import ResetPassword from "./pages/ResetPassword";
import RegisterPage from "./pages/Register";
import EmailVerifyNotificaion from "./pages/EmailVerifyNotificaion";
import SettingsPage from "./pages/Settings";
import DeleteAccount from "./pages/DeleteAccount";
import Leaderboard from "./pages/Leaderboard";
import SeasonLeaderboard from "./pages/SeasonLeaderboard";

const ChatterApp = () => {
  const { currentEvent } = useContext(CurrentRaceEventContext);
  const { isLoggedIn, isVip } = useContext(LoginContext);
  const location = useLocation();
  const { dashboardRoutePaths } = useContext(RaceDashboardLayoutContext);
  const shouldRedirectToRace = (location.state as any)?.isLoginRedirectFrom;

  useAutoPlayEvents();
  return (
    <Paper className="root">
      {!isLoggedIn && !isVip ? (
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route
            path="/forgot-password-confirmation"
            element={<ForgotPasswordConfirmation />}
          />
          <Route path="/new-password" element={<ResetPassword />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route
            path="/email-verification"
            element={<EmailVerifyNotificaion />}
          />
          <Route path="/season-leaderboard/:seasonId" element={<SeasonLeaderboard />} />
          <Route
            path="*"
            element={
              <Navigate
                to="/login"
                state={{
                  isLoginRedirectFrom: location.pathname + location.search,
                }}
              />
            }
          />
        </Routes>
      ) : (
        <>
          {currentEvent ? (
            <Routes>
              <Route path="/" element={<Navigate to="/schedule" replace />} />
              <Route path="/schedule" element={<RaceSchedule />} />
              {dashboardRoutePaths && dashboardRoutePaths.map((path: string) => (
                <Route key={path} path={path} element={<RaceDashboard />} />
              ))}
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/leaderboard/:eventId" element={<Leaderboard />} />
              <Route path="/season-leaderboard/:seasonId" element={<SeasonLeaderboard />} />
              <Route
                path="/delete-account-confirm"
                element={<DeleteAccount />}
              />
              {/* Schedule is default "home" page in case of unknown path */}
              <Route path="*" element={<Navigate to="/schedule" replace />} />
            </Routes>
          ) : (
            <Routes>
              {/* Schedule when no event selected */}
              <Route path="/" element={<Navigate to="/schedule" replace />} />
              {dashboardRoutePaths && dashboardRoutePaths.map((path: string) => (
                <Route key={path} path={path} element={<RaceDashboard />} />
              ))}
              <Route path="/schedule" element={<RaceSchedule />} />
              <Route path="/eventStreams" element={<RaceDashboard />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/leaderboard/:eventId" element={<Leaderboard />} />
              <Route path="/season-leaderboard/:seasonId" element={<SeasonLeaderboard />} />
              <Route
                path="/delete-account-confirm"
                element={<DeleteAccount />}
              />
              <Route
                path="*"
                element={
                  shouldRedirectToRace ? (
                    <Navigate to={shouldRedirectToRace} replace />
                  ) : (
                    <Navigate to="/schedule" replace />
                  )
                }
              />
            </Routes>
          )}
          <AutoPlayPopover />
          <RaceEndedOverlay />
        </>
      )}
      <ToastContainer
        position="top-center"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        draggable
        pauseOnHover
      />
    </Paper>
  );
};

export default ChatterApp;